import { useSearchParams } from 'react-router-dom';

export const useGetUrlParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramKeys = Array.from(searchParams.keys());

  const params = paramKeys.reduce<Record<string, string | undefined>>(
    (acc, p) => {
      acc[p] = searchParams.get(p) ?? undefined;
      return acc;
    },
    {},
  );

  return [params, setSearchParams] as const;
};
